// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"1cdb5e5e","397":"162ed543","484":"14cb0921","617":"4d337883","842":"01821987"}[chunkId] + ".chunk.js";
};